import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dress-design',
  templateUrl: './dress-design.component.html',
  styleUrls: ['./dress-design.component.scss']
})
export class DressDesignComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
